/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    StorageRequest,
    StorageRequestFromJSON,
    StorageRequestToJSON,
    StorageResponse,
    StorageResponseFromJSON,
    StorageResponseToJSON,
} from '../models';

export interface GetSharedStorageValueRequest {
    name: string;
}

export interface GetUserStorageValueRequest {
    name: string;
}

export interface SetSharedStorageValueRequest {
    name: string;
    storageRequest: StorageRequest;
}

export interface SetUserStorageValueRequest {
    name: string;
    storageRequest: StorageRequest;
}

/**
 * 
 */
export class SharedstorageApi extends runtime.BaseAPI {

    /**
     * ### Required permissions    * Authenticated user 
     */
    async getSharedStorageValueRaw(requestParameters: GetSharedStorageValueRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<StorageResponse>> {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling getSharedStorageValue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/private/shared-storage/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StorageResponseFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * Authenticated user 
     */
    async getSharedStorageValue(requestParameters: GetSharedStorageValueRequest, initOverrides?: RequestInit): Promise<StorageResponse> {
        const response = await this.getSharedStorageValueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * Authenticated user 
     */
    async getUserStorageValueRaw(requestParameters: GetUserStorageValueRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<StorageResponse>> {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling getUserStorageValue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/private/user-storage/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StorageResponseFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * Authenticated user 
     */
    async getUserStorageValue(requestParameters: GetUserStorageValueRequest, initOverrides?: RequestInit): Promise<StorageResponse> {
        const response = await this.getUserStorageValueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * Authenticated user 
     */
    async setSharedStorageValueRaw(requestParameters: SetSharedStorageValueRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<StorageResponse>> {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling setSharedStorageValue.');
        }

        if (requestParameters.storageRequest === null || requestParameters.storageRequest === undefined) {
            throw new runtime.RequiredError('storageRequest','Required parameter requestParameters.storageRequest was null or undefined when calling setSharedStorageValue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/private/shared-storage/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StorageRequestToJSON(requestParameters.storageRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StorageResponseFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * Authenticated user 
     */
    async setSharedStorageValue(requestParameters: SetSharedStorageValueRequest, initOverrides?: RequestInit): Promise<StorageResponse> {
        const response = await this.setSharedStorageValueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ### Required permissions    * Authenticated user 
     */
    async setUserStorageValueRaw(requestParameters: SetUserStorageValueRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<StorageResponse>> {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling setUserStorageValue.');
        }

        if (requestParameters.storageRequest === null || requestParameters.storageRequest === undefined) {
            throw new runtime.RequiredError('storageRequest','Required parameter requestParameters.storageRequest was null or undefined when calling setUserStorageValue.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/2/private/user-storage/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StorageRequestToJSON(requestParameters.storageRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StorageResponseFromJSON(jsonValue));
    }

    /**
     * ### Required permissions    * Authenticated user 
     */
    async setUserStorageValue(requestParameters: SetUserStorageValueRequest, initOverrides?: RequestInit): Promise<StorageResponse> {
        const response = await this.setUserStorageValueRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
